import React, { Component } from 'react';
import FormModal from 'components/shared/modal/FormModal';
import PropTypes from 'prop-types';
import './SelectClientModal.css';
import SearchableDropDown from 'components/shared/dropdown/SearchableDropDown';
import Button from 'components/shared/button/Button';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';

class SelectClientModal extends Component {
  static propTypes = {
    loadOptions: PropTypes.func.isRequired,
    selectedClient: PropTypes.shape({}),
    show: PropTypes.bool,
    onClientSelect: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
  };

  static defaultProps = {
    selectedClient: null,
    show: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      showConfirmationModal: false,
    };
  }

  handleConfirmation = (result) => {
    if (result) {
      this.props.onConfirm();
    }
    this.setState({
      showConfirmationModal: false,
    });
  };

  handleSelect = (client) => {
    this.props.onClientSelect(client);
  };

  render() {
    const { loadOptions, selectedClient, show, onClose } = this.props;
    return (
      <FormModal
        className="transfer-select-client-modal"
        show={show}
        title="Select Client"
        onClose={() => onClose()}
      >
        <div className="drop-down-container">
          <SearchableDropDown
            autoload={false}
            className="searchable-container"
            loadOptions={(value) => loadOptions(value)}
            placeholder="Search a new Client"
            value={selectedClient !== null ? selectedClient.value : null}
            onChange={this.handleSelect}
          />
        </div>

        <Button
          className="button-orange"
          disabled={selectedClient === null}
          label="Confirm"
          onClick={() => this.setState({ showConfirmationModal: true })}
        />

        <ConfirmationModal
          show={this.state.showConfirmationModal}
          message="Are you sure?"
          onHide={this.handleConfirmation}
        />
      </FormModal>
    );
  }
}

export default SelectClientModal;



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/transfer/SelectClientModal.js